import { render } from "./Header.vue?vue&type=template&id=33bc72b4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=33bc72b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33bc72b4"

export default script